import {
  FETCH_EXECUTIVE_REQUESTS_REQUEST,
  FETCH_EXECUTIVE_REQUESTS_SUCCESS,
  FETCH_EXECUTIVE_REQUESTS_FAILURE,
  FETCH_EXECUTIVE_REQUEST_DETAILS_REQUEST,
  FETCH_EXECUTIVE_REQUEST_DETAILS_SUCCESS,
  FETCH_EXECUTIVE_REQUEST_DETAILS_FAILURE,
  ADD_EXECUTIVE_REQUEST_REQUEST,
  ADD_EXECUTIVE_REQUEST_SUCCESS,
  ADD_EXECUTIVE_REQUEST_FAILURE,
  ADD_APPROVE_REQUEST_REQUEST,
  ADD_APPROVE_REQUEST_SUCCESS,
  ADD_APPROVE_REQUEST_FAILURE,
  ADD_ATTEST_REQUEST_REQUEST,
  ADD_ATTEST_REQUEST_SUCCESS,
  ADD_ATTEST_REQUEST_FAILURE,
  ADD_VERIFY_REQUEST_REQUEST,
  ADD_VERIFY_REQUEST_SUCCESS,
  ADD_VERIFY_REQUEST_FAILURE,
  ADD_REJECT_REQUEST_REQUEST,
  ADD_REJECT_REQUEST_SUCCESS,
  ADD_REJECT_REQUEST_FAILURE,
  ADD_PAY_REQUEST_REQUEST,
  ADD_PAY_REQUEST_SUCCESS,
  ADD_PAY_REQUEST_FAILURE,
  ADD_QUERY_REQUEST_REQUEST,
  ADD_QUERY_REQUEST_SUCCESS,
  ADD_QUERY_REQUEST_FAILURE,
  FETCH_EXECUTIVE_VOUCHERS_REQUEST,
  FETCH_EXECUTIVE_VOUCHERS_SUCCESS,
  FETCH_EXECUTIVE_VOUCHERS_FAILURE,
  CLEAR_EXECUTIVE_REQUESTS_ERROR,
  UPDATE_EXECUTIVE_REQUEST_REQUEST,
  UPDATE_EXECUTIVE_REQUEST_SUCCESS,
  UPDATE_EXECUTIVE_REQUEST_FAILURE,
} from "../actions/executiveRequestActionTypes";

const initialState = {
  executiveRequests: [],
  executiveDetails: null,
  vouchers: null,
  isLoading: false,
  error: null,
};

const executiveRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_EXECUTIVE_REQUEST_REQUEST:
      return { ...state, isLoading: true, error: null };
    case ADD_EXECUTIVE_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        executiveRequests: [...state.executiveRequests, action.payload],
        error: null,
      };
    case ADD_EXECUTIVE_REQUEST_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case UPDATE_EXECUTIVE_REQUEST_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_EXECUTIVE_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        executiveRequests: state.executiveRequests.map((request) =>
          request.id === action.payload.id ? action.payload : request,
        ),
        executiveDetails:
          state.executiveDetails?.id === action.payload.id
            ? action.payload
            : state.executiveDetails,
        error: null,
      };
    case UPDATE_EXECUTIVE_REQUEST_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case FETCH_EXECUTIVE_REQUESTS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FETCH_EXECUTIVE_REQUESTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        executiveRequests: action.payload,
        error: null,
      };
    case FETCH_EXECUTIVE_REQUESTS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case FETCH_EXECUTIVE_REQUEST_DETAILS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FETCH_EXECUTIVE_REQUEST_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        executiveDetails: action.payload,
        error: null,
      };
    case FETCH_EXECUTIVE_REQUEST_DETAILS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case ADD_APPROVE_REQUEST_REQUEST:
    case ADD_ATTEST_REQUEST_REQUEST:
    case ADD_VERIFY_REQUEST_REQUEST:
    case ADD_REJECT_REQUEST_REQUEST:
    case ADD_PAY_REQUEST_REQUEST:
    case ADD_QUERY_REQUEST_REQUEST:
      return { ...state, isLoading: true, error: null };
    case ADD_APPROVE_REQUEST_SUCCESS:
    case ADD_ATTEST_REQUEST_SUCCESS:
    case ADD_VERIFY_REQUEST_SUCCESS:
    case ADD_REJECT_REQUEST_SUCCESS:
    case ADD_PAY_REQUEST_SUCCESS:
    case ADD_QUERY_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        executiveDetails: action.payload,
        error: null,
      };
    case ADD_APPROVE_REQUEST_FAILURE:
    case ADD_ATTEST_REQUEST_FAILURE:
    case ADD_VERIFY_REQUEST_FAILURE:
    case ADD_REJECT_REQUEST_FAILURE:
    case ADD_PAY_REQUEST_FAILURE:
    case ADD_QUERY_REQUEST_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case FETCH_EXECUTIVE_VOUCHERS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FETCH_EXECUTIVE_VOUCHERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        vouchers: action.payload,
        error: null,
      };
    case FETCH_EXECUTIVE_VOUCHERS_FAILURE:
      return { ...state, isLoading: false, error: null };
    case CLEAR_EXECUTIVE_REQUESTS_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
};

export default executiveRequestReducer;
